var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C15.866 2 19 5.13401 19 9C19.14 12.13 16.63 16.3 12.81 21.58C12.6219 21.8398 12.3207 21.9936 12 21.9936C11.6793 21.9936 11.3781 21.8398 11.19 21.58C7.36999 16.29 4.85999 12.12 4.99999 9C4.99999 5.13401 8.13399 2 12 2ZM12 19.31C14.67 15.53 17.14 11.54 17 9.09V9.06V9C17 6.23858 14.7614 4 12 4C9.23856 4 6.99999 6.23858 6.99999 9V9.06C6.85999 11.51 9.32999 15.5 12 19.31ZM12 6C10.3431 6 8.99999 7.34315 8.99999 9C8.99999 10.6569 10.3431 12 12 12C13.6568 12 15 10.6569 15 9C15 8.20435 14.6839 7.44129 14.1213 6.87868C13.5587 6.31607 12.7956 6 12 6ZM11 9C11 9.55228 11.4477 10 12 10C12.5523 10 13 9.55228 13 9C13 8.44772 12.5523 8 12 8C11.4477 8 11 8.44772 11 9Z",
    fill: "#231F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.f9d745a06e3fde88da0b40325deed211.svg";
export { ForwardRef as ReactComponent };